import React from 'react'

export default function CollectionsIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3333 5.33329H13.6667L12 3.66663H7C6.08333 3.66663 5.34167 4.41663 5.34167 5.33329L5.33333 15.3333C5.33333 16.25 6.08333 17 7 17H20.3333C21.25 17 22 16.25 22 15.3333V6.99996C22 6.08329 21.25 5.33329 20.3333 5.33329ZM2 6.99996H3.66667V18.6666H18.6667V20.3333H3.66667C2.75 20.3333 2 19.5833 2 18.6666L2.00833 11.1666H2V6.99996ZM19.5 14.5H7.83333L11.5833 9.49996L14.5 13.2583L16.5833 10.75L19.5 14.5ZM7 15.3333H20.3333V6.99996H12.975L12.4833 6.50829L11.3083 5.33329H7V15.3333Z"
        fill="#066F90"
      />
    </svg>
  )
}
